<template>
  <div class="loading-inside-wrap">
    <div class="loading-inside">
      <i class="fa fa-spinner fa-pulse fa-3x"></i>
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
};
</script>
